import { useEffect, useRef, useState } from 'react';

/**
 * Hook: triggers an animation when element scrolls into view.
 * Returns { ref, isVisible } — apply ref to the element and toggle classes off isVisible.
 */
export const useScrollReveal = (options = {}) => {
  const ref = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node) return undefined;

    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: options.threshold ?? 0.15, rootMargin: options.rootMargin ?? '0px 0px -60px 0px' }
    );
    obs.observe(node);
    return () => obs.disconnect();
  }, [options.threshold, options.rootMargin]);

  return { ref, isVisible };
};

export default useScrollReveal;
